module.exports = __webpack_public_path__ + "static/media/3DHubs.49248f76.png";